import Vue from 'vue'
import '@/scss/app.scss'
import App from './App.vue'
import store from './store'
import router from './router'
import svgJs from './vueSvgPlugin'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import config from './config'
import i18n from './i18n'
import LoadScript from 'vue-plugin-load-script'
import moment from 'moment-timezone'
import 'moment/locale/es' // without this line it didn't work
import ReactiveSearch from '@appbaseio/reactivesearch-vue'
import VueProgressBar from 'vue-progressbar'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

Vue.use(ReactiveSearch)
Vue.use(VueProgressBar)
moment.locale('es')
Vue.config.productionTip = false

Vue.use(LoadScript)
import '@mdi/font/css/materialdesignicons.css'

import 'perfect-scrollbar/css/perfect-scrollbar.css'

import Dialog from 'v-dialogs'
Vue.use(Dialog)

import VueFab from 'vue-float-action-button'
Vue.use(VueFab)

import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'
Vue.use(VueToast)
Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID
  },
  Storage: {
    region: config.s3.REGION,
    bucket: config.s3.BUCKET,
    identityPoolId: config.cognito.IDENTITY_POOL_ID
  },
  API: {
    endpoints: [
      {
        name: 'ecobanka',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      }
    ]
  }
})
Vue.use(AmplifyPlugin, AmplifyModules)
Vue.use(svgJs)
/*
 * Buefy
 * */
import Buefy from 'buefy'
Vue.use(Buefy)

/*
 * VTooltip
 * */
import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

/*
 * Html El
 * */
const $html = document.getElementsByTagName('html')[0]

/*
 * JbUtils
 * Provides some event setters to control overlays and stuff
 * */

import JbUtils from '@/classes/JbUtils'
const jbUtils = new JbUtils($html, store)

/* Make JbUtils available inside Vue */
Vue.prototype.$jbUtils = jbUtils

/* These components are used in recursion algorithm */
import AsideMenuListPlain from '@/components/theme/AsideMenuListPlain'
Vue.component('AsideMenuListPlain', AsideMenuListPlain)

//import messages from './i18n/messages'

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import { localize } from 'vee-validate'
import en from 'vee-validate/dist/locale/en.json'
import es from 'vee-validate/dist/locale/es.json'

localize({
  en,
  es
})

import ProgressBar from 'vuejs-progress-bar'
Vue.use(ProgressBar)

import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA-UUOo9gCZpnz79VAk2zS_zFN_xnHFdoY',
    libraries: 'places'
  }
})

import underscore from 'vue-underscore'
import './registerServiceWorker'
Vue.use(underscore)

const lang = localStorage.getItem('locale') || 'es'

localize(lang)

Vue.filter('formatTimestamp', function(value) {
  return moment
    .utc(value, 'YYYYMMDDHHmmss')
    .tz('Europe/Madrid')
    .format('DD-MM-YYYY, h:mm:ss a')
})

Vue.filter('formatTimestampShort', function(value) {
  return moment
    .utc(value, 'YYYYMMDDHHmmss')
    .tz('Europe/Madrid')
    .format('DD-MM-YYYY')
})

Vue.filter('toCurrency', function(value) {
  if (typeof value !== 'number') {
    return value
  }
  var formatter = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: '€',
    minimumFractionDigits: 0
  })
  return formatter.format(value)
})

Sentry.init({
  Vue,
  dsn:
    'https://4059481e2c794da189365503ce0ef3cc@o377015.ingest.sentry.io/4504122409091072',
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', 'app.myneofintech.com', /^\//]
    })
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0
})

window.App = new Vue({
  i18n,
  store,
  router,
  components: {},
  render: h => h(App),
  mounted() {
    $html.classList.remove('has-spinner-active')
  }
}).$mount('#app')
